import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { Segment, TransportItem, TransportModeCode } from "../../types";
import FlightCard from "../Flights/FlightCard";
import OfferCard from "./TransportCard";
import { formatDate, formatTime } from "../../functions/Utils";
import api from "../../api";
import { apiRoutes } from "../../routes/routes";

interface TransportDetailModal {
  show: boolean;
  onClose: () => void;
  selectedOffer: TransportItem | null;
  selectedAgentParams: any;
}

const formatDuration = (minutes: number) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  return `${h}h ${m}m`;
};

const TransportDetailModal: React.FC<TransportDetailModal> = ({
  show,
  onClose,
  selectedOffer,
  selectedAgentParams,
}) => {
  const [mode, setMode] = useState<TransportModeCode>(1);
  const [segments, setSegments] = useState<Segment[] | TransportItem[]>([]);

  const redirectToBooking = async (offer: TransportItem) => {

    try {
      
      const response = await api.post(
        apiRoutes.redirect_booking,
        {
          offer: offer,
          params: selectedAgentParams,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      window.open(response.data.redirectUrl);
    } catch (err) {}
  };

  useEffect(() => {
    if (!selectedOffer) return;
    setMode(
      selectedOffer.segments
        ? selectedOffer.segments[0].mode
        : selectedOffer.modes
        ? selectedOffer.modes[0]
        : 3
    );

    setSegments(
      selectedOffer.segments ? selectedOffer.segments : [selectedOffer]
    );
  }, [selectedOffer]);

  return (
    <div>
      {selectedOffer && (
        <Modal show={show} onHide={onClose} size="lg" centered scrollable>
          <Modal.Header closeButton className="border-0">
            <Modal.Title>Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {mode == 1 ? (
              <FlightCard flight={selectedOffer} />
            ) : (
              <OfferCard offer={selectedOffer} />
            )}
          </Modal.Body>

          <Modal.Body className="bg-light">
            <h6 className="mt-3 mb-2">Segments</h6>
            <div className="card">
              <div className="card-body p-0">
                {segments.map((seg, idx) => (
                  <div key={idx}>
                    {"ch_time" in seg && seg.ch_time && seg.ch_time > 0 && (
                      <div className="mx-3 py-2 border-top border-bottom">
                        <small className="text-info">
                          {formatDuration(seg.ch_time)}
                        </small>
                      </div>
                    )}
                    <div className="p-3">
                      <div className="d-flex align-items-center mb-2">
                        <img
                          src={"info" in seg ? seg.info.img : seg.cpd.img}
                          alt={"info" in seg ? seg.info.n : seg.cpd.n}
                          style={{
                            width: 60,
                            height: 40,
                            objectFit: "contain",
                            marginRight: 10,
                          }}
                        />
                        <div>
                          <strong>
                            {"info" in seg ? seg.info.n : seg.cpd.n}
                          </strong>
                          <div className="text-muted">
                            {"info" in seg ? "#" + seg.info.number : ""}
                          </div>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          {seg.nf} <br />
                          {seg.nt}
                        </div>
                        <div>
                          {formatDate(seg.dep)} -{" "}
                          <strong>{formatTime(seg.dep)}</strong> <br />
                          {formatDate(seg.arr)} -{" "}
                          <strong>{formatTime(seg.arr)}</strong>
                        </div>
                        <div>
                          <strong>{formatDuration(seg.du)}</strong>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => redirectToBooking(selectedOffer)}
            >
              Select
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </div>
  );
};

export default TransportDetailModal;
